<template>
  <div>
    <div>
      <vxe-grid
        ref="table"
        show-overflow
        highlight-hover-row
        :loading="loading"
        :data="tableData"
        :height="tableHeight"
        :columns="tableColumns"
        :toolbar-config="tableToolbar"
        :edit-rules="validRules"
        :radio-config="{
          trigger: 'row',
          highlight: true,
        }"
        row-key
        size="small"
        resizable
        border
        :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      >
        <template v-slot:toolbar_form>
          <slot name="header">
            <div class="side-frame-warning">
              <el-button type="primary" icon="el-icon-plus" @click="add()"
                >添加</el-button
              >
              <el-button
                type="danger"
                icon="el-icon-delete"
                @click="$refs.table.removeCheckboxRow()"
                >删除</el-button
              >
            </div>
          </slot>
        </template>
      </vxe-grid>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {},
    },
    codeData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    falg: String,
  },

  data() {
    return {
      loading: false,
      tableData: [],
      newdata: '',
      tableHeight: 300,
      backDialogVisible: false,
      formData: {
        waybillCode: this.waybillCode,
      },
      validRules: {
        chargesType: [{ required: true, message: '类型必须填写' }],
        settlementMethod: [{ required: true, message: '结算方式必须填写' }],
        amount: [{ required: true, message: '费用必须填写' }],
        feeName: [{ required: true, message: '名称必须填写' }],
      },
      options: [],
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          field: 'chargesType',
          headerAlign: 'center',
          align: 'left',
          minWidth: 100,
          title: '类型',
          editRender: { name: 'ElSelect', options: [] },
        },
        {
          field: 'feeName',
          headerAlign: 'center',
          align: 'left',
          minWidth: 100,
          title: '名称',
          required: 'validRules',
          editRender: {
            name: 'dict-select',
            props: {
              default: true,
              clearable: true,
              filterable: true,
              placeholder: '请输入名称',
              body: { type: 'feeName' },
            },
          },
        },

        {
          field: 'amount',
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          title: '费用',
          editRender: {
            name: 'ElInputNumber',
            attrs: {
              precision: 4,
              placeholder: '请输入费用',
            },
          },
        },
        {
          field: 'settlementMethod',
          headerAlign: 'center',
          align: 'left',
          minWidth: 100,
          title: '结算方式',
          editRender: {
            name: 'dict-select',
            props: {
              default: true,
              clearable: true,
              filterable: true,
              placeholder: '请输入结算方式',
              body: { type: 'settlementMethod' },
            },
          },
        },
        {
          field: 'remark',
          headerAlign: 'center',
          align: 'left',
          minWidth: 100,
          title: '备注',
          editRender: {
            name: 'input',
            attrs: { type: 'text', placeholder: '请输入备注' },
          },
        },
      ],

      sexList: [
        { label: '收入', value: 'A' },
        { label: '支出', value: 'B' },
      ],
    }
  },
  // 当父组件向子组件动态传值时，子组件props首次获取到父组件传来的默认值时，也需要执行函数，需要将immediate设为true
  watch: {
    params: {
      handler(params) {
        this.formData.wayBillSpecialChargesCode =
          params.wayBillSpecialChargesCode
        this.formData.waybillCode = params.waybillCode
        this.formData.dispatchOrderCode = params.dispatchOrderCode
        this.formData.dispatchOrderNo = params.dispatchOrderNo
        this.formData.orderCode = params.orderCode
        this.formData.orderNo = params.orderNo
      },
      immediate: true,
    },
  },
  created() {
    this.tableColumns[2].editRender.options = this.sexList
    this.getData()
  },
  methods: {
    getData() {
      if (this.falg === 'A') {
        return
      }
      this.loading = true
      this.$api
        .bizWaybillSpeciaListApi({
          dispatchOrderCode: this.params.dispatchOrderCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },

    async add(row) {
      const $table = this.$refs.table
      const { row: newRow } = await $table.insertAt({}, row, newRow)
      // await $table.setActiveCell(newRow, 'minMatch')
    },
    async getInsertRecords() {
      const $table = this.$refs.table
      return await $table.getInsertRecords()
    },

    async save() {
      const tableData = this.$refs.table.getTableData()
      // console.log("tableData++++++>",tableData)

      // if (!tableData.fullData || !tableData.fullData.length) {
      //   this.$message.warning('请添加特殊费用信息')
      //   return Promise.reject(false)
      // }
      this.formData.specialChargesList = tableData.fullData

      const result = await this.$refs.table
        .validate()
        .then(() => true)
        .catch(() => false)
      if (!result) return Promise.reject(false)

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      return this.$api
        .bizWaybillSpecialChargesApi(this.formData)
        .then((res) => {
          loadingInstance.close()

          const { status, msg } = res
          this.$message({
            type: status === 200 ? 'success' : 'error',
            message: msg,
          })
          this.newdata = res.body
          return this.newdata
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    async boxSave() {
      const tableData = this.$refs.table.getTableData()
      this.formData.specialChargesList = tableData.fullData
      this.formData.waybillCodeList = this.codeData
      const result = await this.$refs.table
        .validate()
        .then(() => true)
        .catch(() => false)
      if (!result) return Promise.reject(false)
      return this.$api
        .bizWaybillSpecialChargesBoxApi(this.formData)
        .then((res) => {
          const { status, msg } = res
          this.$message({
            type: status === 200 ? 'success' : 'error',
            message: msg,
          })
          this.newdata = res.body
          return this.newdata
        })
    },
  },
}
</script>
